import React, { useEffect } from "react";
import { Col, Row, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Controller } from "react-hook-form";
// import { handlePaymentClaimFilter } from "../../../config/claimSlice.js";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "components/common/MultiSelect";
import {
  GetAllPoyer,
  GetPayerInsurance,
} from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import TextInput from "components/common/custom/forms/BootTextField/TextField.jsx";
import { Archive, Calendar } from "react-bootstrap-icons";
import BootDatePicker from "components/common/custom/forms/BootDatePicker/index.jsx";
import { handlePaymentFilter } from "../config/PaymentSlice.js";
import classNames from "classnames";

const PaymentListFilter = ({ control, watch, setValue, clearErrors, errors, onSubmit, isSubmitted }) => {
  const dispatch = useDispatch();
  const { paymentFilters } = useSelector((state) => state.Payment);
  const { userData } = useSelector((state) => state.auth);
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch",
  );

  const { poyerList, payerInsurance } = useSelector(
    (state) => state.eligibilityCheckList
  );
  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  const payer = watch("payer");


  const handleBranch = (selected) => {
    if (!selected) {
      setValue("branch_id", null);
      dispatch(
        handlePaymentFilter({
          check: "branch_id",
          value: null,
        })
      );
      return;
    }

    const value = {
      branch_name: selected.label,
      branch_id: selected.value,
      branch_cchino: selected?.cchi,
    };
    setValue("branch_id", value);
    dispatch(handlePaymentFilter({ check: "branch_id", value }));
    clearErrors("branch_id");
  };

  const handlePayer = (selected) => {
    if (!selected) {
      setValue("payer", null);
      setValue("insurance", null);
      dispatch(handlePaymentFilter({ check: "payer", value: null }));
      dispatch(
        handlePaymentFilter({
          check: "insurance",
          value: null,
        })
      );
      return;
    }

    const value = {
      payer_name: selected.label,
      payer_id: selected.value,
    };
    setValue("payer", value);
    dispatch(handlePaymentFilter({ check: "payer", value }));
  };

  const handleInsurance = (selected) => {
    if (!selected) {
      setValue("insurance", null);
      dispatch(
        handlePaymentFilter({
          check: "insurance",
          value: null,
        })
      );
      return;
    }

    const value = {
      insurance_company_name: selected.label,
      insurance_company_id: selected.value,
    };
    setValue("insurance", value);
    dispatch(handlePaymentFilter({ check: "insurance", value }));
  };
  const handleStatusType = (selected) => {
    if (!selected) {
      setValue("status", null);
      dispatch(
        handlePaymentFilter({
          check: "status",
          value: null,
        })
      );
      return;
    }

    const value = {
      label: selected.label,
      value: selected.value,
    };
    setValue("status", value);
    dispatch(handlePaymentFilter({ check: "status", value }));
  };

  const handlePaymentNumber = (selected) => {
    setValue("payment_number", selected);
    dispatch(
      handlePaymentFilter({ check: "payment_number", value: selected })
    );
  };


  const handleStartDate = (selected) => {
    setValue("start_date", selected);

    dispatch(
      handlePaymentFilter({
        check: "start_date",
        value: selected,
      })
    );
  };
  const handleEndDate = (selected) => {
    setValue("end_date", selected);

    dispatch(
      handlePaymentFilter({
        check: "end_date",
        value: selected,
      })
    );
  };
  // const handleBatch = (newValue) => {
  //   if (!newValue && !watch("by_received_date")) {
  //     return; // Prevent turning off if the other is also off
  //   }
  //   if (newValue) {
  //     setValue("by_received_date", false);
  //     dispatch(
  //       handlePaymentClaimFilter({ check: "by_received_date", value: false })
  //     );
  //   }
  //   setValue("by_batch", newValue);
  //   dispatch(handlePaymentClaimFilter({ check: "by_batch", value: newValue }));
  // };

  // const handleReceivedDate = (newValue) => {
  //   if (!newValue && !watch("by_batch")) {
  //     return; // Prevent turning off if the other is also off
  //   }
  //   if (newValue) {
  //     setValue("by_batch", false);
  //     dispatch(handlePaymentClaimFilter({ check: "by_batch", value: false }));
  //   }
  //   setValue("by_received_date", newValue);
  //   dispatch(
  //     handlePaymentClaimFilter({ check: "by_received_date", value: newValue })
  //   );
  // };

  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
  }, []);

  useEffect(() => {
    const selectedPayer = watch("payer");

    if (selectedPayer && selectedPayer.payer_id) {
      dispatch(GetPayerInsurance({ payer_id: selectedPayer.payer_id }));
    } else {
      dispatch(GetPayerInsurance({ payer_id: null }));
    }
  }, [watch("payer")]);

  useEffect(() => {
    setValue("payer", paymentFilters?.payer);
    if (paymentFilters?.branch_id) {
      setValue("branch_id", paymentFilters?.branch_id);
    } else if (selectedBranch) {
      const defaultBranch = {
        branch_name: selectedBranch.label || selectedBranch.branch_name,
        branch_id: selectedBranch.value || selectedBranch.branch_id,
        branch_cchino: selectedBranch.cchi || selectedBranch.branch_cchino,
      };
      setValue("branch_id", defaultBranch);
      dispatch(handlePaymentFilter({ check: "branch_id", value: defaultBranch }));
    } else {
      setValue("branch_id", null);
    }
    setValue("insurance", paymentFilters?.insurance);
    setValue("payment_number", paymentFilters?.payment_number);
    setValue("claim_number", paymentFilters?.claim_number);
    setValue("status", paymentFilters?.status);
    setValue("start_date", paymentFilters?.start_date);
    setValue("end_date", paymentFilters?.end_date);
    const byBatch = paymentFilters?.by_batch || false;
    const byReceivedDate = paymentFilters?.by_received_date || false;
    if (!byBatch && !byReceivedDate) {
      // Default to by_batch if both are false
      setValue("by_batch", true);
      dispatch(handlePaymentFilter({ check: "by_batch", value: true }));
      setValue("by_received_date", false);
    } else {
      setValue("by_batch", byBatch);
      setValue("by_received_date", byReceivedDate);
    }
  }, []);

  return (
    <Form onSubmit={onSubmit} noValidate className="p-0">
      <Row className="align-items-center">
        {(Number(branchSetting?.list) === 1 && userData?.employee?.syspri_id === 1) || userData?.employee?.syspri_id === 2 ? (
          <Col xs={12} sm={6} md={3} xl={2}>
            <label className="form-label">Branch <span className="text-danger">*</span></label>
            <Controller
              name="branch_id"
              control={control}
              rules={{ required: "Branch is required" }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  disabled={userData?.employee?.syspri_id === 2}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  errors={errors}
                  isMulti={false}
                  options={allBranches?.map((item) => ({
                    value: item.branch_id,
                    label: item.branch_name,
                    cchi: item.branch_cchino,
                  }))}
                  isClearable={true}

                  value={
                    field.value
                      ? {
                        value: field.value.branch_id,
                        label: field.value.branch_name,
                        cchi: field.value.branch_cchino,
                      }
                      : null
                  }
                  onChange={(selected) => handleBranch(selected)}
                  formatOptionLabel={({ label }) => <div>{label}</div>}
                  getOptionValue={(option) => option.value}
                  placeholder="Choose ..."
                />
              )}
            />
          </Col>
        ) : null}
        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Group controlId="payer">
            <Form.Label>Payer</Form.Label>
            <Controller
              name="payer"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <>
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    errors={errors}
                    size="sm"
                    options={poyerList?.map((poyer) => ({
                      value: poyer.payer_id,
                      label: poyer.payer_name,
                    }))}
                    isClearable={true}
                    placeholder="Choose..."
                    value={
                      field.value
                        ? {
                          value: field.value.payer_id,
                          label: field.value.payer_name,
                        }
                        : null
                    }
                    onChange={(selected) => handlePayer(selected)}
                  />
                </>
              )}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Group controlId="insurance">
            <Form.Label>Insurance</Form.Label>
            <Controller
              name="insurance"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <>
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isClearable={true}
                    isMulti={false}
                    size="sm"
                    options={payerInsurance?.map((poyer) => ({
                      value: poyer.insurance_company_id,
                      label: poyer.insurance_company_name,
                    }))}
                    placeholder="Choose..."
                    className={error ? "is-invalid" : ""}
                    value={
                      field.value
                        ? {
                          value: field.value.insurance_company_id,
                          label: field.value.insurance_company_name,
                        }
                        : null
                    }
                    onChange={(selected) => handleInsurance(selected)}
                  />
                </>
              )}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <TextInput
            name="payment_number"
            label="Payment Number "
            size="sm"
            onChange={(selected) => handlePaymentNumber(selected)}
            control={control}
            placeholder="Payment Number"
          />
        </Col>

        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Group controlId="status">
            <Form.Label>Status</Form.Label>
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <>
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    size="sm"
                    options={[
                      { value: "paid", label: "Paid" },
                      { value: "verified", label: "Verified" },
                    ]}
                    isClearable={true}
                    value={
                      field.value
                        ? {
                          value: field.value?.value,
                          label: field.value?.label,
                        }
                        : null
                    }
                    onChange={(selected) => handleStatusType(selected)}
                    placeholder="Choose..."
                  />
                </>
              )}
            />
          </Form.Group>
        </Col>
        {/* <Col xs={12} sm={6} md={3} xl={2}>
          <Row className="mt-4">
            <Col xs={6}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip className="bg-primary rounded text-primary">
                    Batch
                  </Tooltip>
                }
              >
                <div>
                  <Controller
                    name="by_batch"
                    control={control}
                    render={({ field }) => (
                      <div
                        className={`border d-flex cursor-pointer py-x justify-content-center gap-2 align-items-center rounded ${field.value
                            ? "badge-subtle-primary border-primary"
                            : "border"
                          }`}
                        onClick={() => {
                          const newValue = !field.value;
                          handleBatch(newValue);
                        }}
                        style={{ userSelect: "none" }}
                      >
                        <Archive className="ms-2" />
                        {field.value ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 512 512"
                          >
                            <path
                              d="M369.16 174.77c7.81 7.81 7.81 20.48 0 28.29L234.99 337.23c-7.81 7.81-20.47 7.81-28.29 0l-63.87-63.88c-7.81-7.81-7.81-20.47 0-28.28 7.81-7.81 20.47-7.81 28.28 0l49.73 49.73L340.86 175.75c7.81-7.81 20.48-7.81 28.29 0zM512 256c0 141.5-114.52 256-256 256S0 397.5 0 256 114.52 0 256 0s256 114.52 256 256zm-40 0c0-119.39-96.62-216-216-216S40 136.61 40 256s96.62 216 216 216 216-96.62 216-216z"
                              fill="#084298"
                            />
                          </svg>
                        ) : (
                          <svg width="18" height="18" viewBox="0 0 512 512">
                            <circle
                              cx="256"
                              cy="256"
                              r="216"
                              stroke="#bcbcbc"
                              strokeWidth="40"
                              fill="none"
                            />
                          </svg>
                        )}
                      </div>
                    )}
                  />
                </div>
              </OverlayTrigger>
            </Col>

            <Col xs={6}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip className="bg-success rounded text-success">
                    Received Date
                  </Tooltip>
                }
              >
                <div>
                  <Controller
                    name="by_received_date"
                    control={control}
                    render={({ field }) => (
                      <div
                        className={`border d-flex cursor-pointer py-x justify-content-center gap-2 align-items-center rounded ${field.value
                            ? "badge-subtle-success border-success"
                            : "border"
                          }`}
                        onClick={() => {
                          const newValue = !field.value;
                          handleReceivedDate(newValue);
                        }}
                        style={{ userSelect: "none" }}
                      >
                        <Calendar className="ms-2" />
                        {field.value ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 512 512"
                          >
                            <path
                              d="M369.16 174.77c7.81 7.81 7.81 20.48 0 28.29L234.99 337.23c-7.81 7.81-20.47 7.81-28.29 0l-63.87-63.88c-7.81-7.81-7.81-20.47 0-28.28 7.81-7.81 20.47-7.81 28.28 0l49.73 49.73L340.86 175.75c7.81-7.81 20.48-7.81 28.29 0zM512 256c0 141.5-114.52 256-256 256S0 397.5 0 256 114.52 0 256 0s256 114.52 256 256zm-40 0c0-119.39-96.62-216-216-216S40 136.61 40 256s96.62 216 216 216 216-96.62 216-216z"
                              fill="#00894f"
                            />
                          </svg>
                        ) : (
                          <svg width="18" height="18" viewBox="0 0 512 512">
                            <circle
                              cx="256"
                              cy="256"
                              r="216"
                              stroke="#bcbcbc"
                              strokeWidth="40"
                              fill="none"
                            />
                          </svg>
                        )}
                      </div>
                    )}
                  />
                </div>
              </OverlayTrigger>
            </Col>
          </Row>
        </Col> */}
        <Col xs={12} sm={6} md={3} xl={2}>
          <BootDatePicker
            name="start_date"
            label="Start Date"
            size="sm"
            control={control}
            errors={errors}
            isRequired={true}
            rules={{
              required: true
            }}
            selected={watch("start_date")}
            onChange={(date) => handleStartDate(date)}
            placeholder="dd/mm/yyyy"
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <BootDatePicker
            name="end_date"
            label="End Date"
            size="sm"
            control={control}
            selected={watch("end_date")}
            errors={errors}
            isRequired={true}
            rules={{
              required: true
            }}
            onChange={(date) => handleEndDate(date)}
            placeholder="dd/mm/yyyy"
          />
        </Col>
      </Row>
    </Form>
  );
};

export default PaymentListFilter;
